"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncSubstituteAvailabilityApiResponseSchema = exports.syncSubstituteAvailabilityApiPayloadSchema = void 0;
const zod_1 = require("zod");
const event_schema_1 = require("../global/event.schema");
exports.syncSubstituteAvailabilityApiPayloadSchema = zod_1.z.object({
    rangeStart: zod_1.z.string().date(),
    rangeEnd: zod_1.z.string().date(),
    entries: zod_1.z.array(zod_1.z.object({
        date: zod_1.z.string().date(),
        period: zod_1.z.enum(event_schema_1.periodsOfTheDayWithoutAllday),
    })),
});
exports.syncSubstituteAvailabilityApiResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
});
